import { render, staticRenderFns } from "./PatientDoseSpotActiveMedicationsV1.vue?vue&type=template&id=6513bdd6&scoped=true&"
import script from "./PatientDoseSpotActiveMedicationsV1.vue?vue&type=script&lang=js&"
export * from "./PatientDoseSpotActiveMedicationsV1.vue?vue&type=script&lang=js&"
import style0 from "./PatientDoseSpotActiveMedicationsV1.vue?vue&type=style&index=0&id=6513bdd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6513bdd6",
  null
  
)

export default component.exports